module.exports = __webpack_public_path__ + "static/media/activities-cover.14c5a72d.png";